export default __webpack_public_path__ + "static/media/Change page style Journal.9ca824ee.mp4";